<ng-container *ngIf="employment">
  <div
    class="employment-list-item"
    [class.is-canceled]="employment?.status === EmploymentStatusEnum.CANCELED"
    (appVisible)="subscribeUsersOfEmployment(employment._id)"
    [appVisibleCheckAgain]="false"
    [attr.data-cy]="'employment-list-item-' + employment._id">
    <div
      class="status-bar"
      [matTooltip]="
        evaluatedEmploymentStatus ===
        EvaluatedEmploymentStatusEnum.ACTION_REQUIRED
          ? ('noOpenInvitations' | i18n | titlecase)
          : evaluatedEmploymentStatus === EvaluatedEmploymentStatusEnum.CLOSED
          ? ('booked' | i18n | titlecase)
          : evaluatedEmploymentStatus ===
            EvaluatedEmploymentStatusEnum.HAS_AVAILABLE_INVITEES
          ? ('hasAvailablePeople' | i18n | titlecase)
          : ('waitingForResponse' | i18n | titlecase)
      "
      [matTooltipShowDelay]="100"
      matTooltipPosition="above"
      [class.status-action-required]="
        evaluatedEmploymentStatus ===
        EvaluatedEmploymentStatusEnum.ACTION_REQUIRED
      "
      [class.status-closed]="
        evaluatedEmploymentStatus === EvaluatedEmploymentStatusEnum.CLOSED
      "
      [class.status-has-available-invitees]="
        evaluatedEmploymentStatus ===
        EvaluatedEmploymentStatusEnum.HAS_AVAILABLE_INVITEES
      "></div>
    <div class="header-meta">
      <app-employment-date [employment]="employment"></app-employment-date>
      <app-employment-counts [employment]="employment"></app-employment-counts>
    </div>
    <app-employment-organisation-heading
      class="employment-heading"
      [employment]="employment"></app-employment-organisation-heading>
    <app-dispo-employment-details-table
      class="details-table"
      hideAgency
      [employment]="employment"></app-dispo-employment-details-table>
    <ng-container *ngIf="overviewInvitees$ | async as overviewInvitees">
      <div
        *ngIf="overviewInvitees.length > 0"
        class="light-table employees-list">
        <app-employment-invitee-list-item
          class="light-table-list-item light-table-interactable-item"
          *ngFor="let invitee of overviewInvitees"
          [loggedInCustomer]="loggedInCustomer"
          [employment]="employment"
          [employmentCustomer]="(customerOfEmployment$ | async) || undefined"
          [isDisabled]="false"
          (click)="$event.stopPropagation()"
          [fromDate]="employment.startDate | convertToDateObject"
          [toDate]="employment.endDate | convertToDateObject"
          [invitee]="invitee"></app-employment-invitee-list-item>
      </div>
    </ng-container>
    <div class="employment-footer">
      <div class="start-items"></div>
      <div class="end-items">
        <button
          *ngIf="canCancel$ | async"
          class="outline-pill-button text-error"
          type="button"
          (click)="$event.stopPropagation(); cancelEmployment()">
          <mat-icon svgIcon="close"></mat-icon>
          {{ ("cancelItem" | i18n) || "stornieren" | titlecase }}
        </button>
        <button
          class="outline-pill-button icon-only"
          type="button"
          [matMenuTriggerFor]="actionsMenu"
          (click)="$event.stopPropagation()"
          data-cy="employment-actions-menu-button">
          <mat-icon svgIcon="menu-dot"></mat-icon>
        </button>
      </div>
    </div>

    <mat-menu
      #actionsMenu="matMenu"
      class="fixed-icon-mat-menu themed">
      <button
        mat-menu-item
        type="button"
        data-cy="duplicate-employment-button"
        (click)="duplicateEmployment()">
        <mat-icon svgIcon="duplicate-copy"></mat-icon>
        {{ ("duplicate" | i18n) || "duplizieren" | titlecase }}
      </button>
    </mat-menu>
  </div>
</ng-container>
